import type { SearchProvider, SearchPattern } from './search-registry';

export interface PatternMatch {
  provider: SearchProvider;
  pattern: SearchPattern;
  match: RegExpMatchArray;
  route: string;
  label: string;
}

/**
 * Match user input against all registered patterns.
 * Returns matches sorted by priority (highest first).
 */
export function matchInput(input: string, providers: SearchProvider[]): PatternMatch[] {
  const trimmed = input.trim();
  if (!trimmed) return [];

  const matches: PatternMatch[] = [];

  for (const provider of providers) {
    if (!provider.patterns) continue;
    for (const pattern of provider.patterns) {
      const match = trimmed.match(pattern.test);
      if (match) {
        matches.push({
          provider,
          pattern,
          match,
          route: pattern.getRoute(match),
          label: pattern.label,
        });
      }
    }
  }

  return matches.sort((a, b) => b.pattern.priority - a.pattern.priority);
}
